import Icon from '../components/Icon.vue'

Icon.register({
  poo: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M451.4 369.1c34.3 5.5 60.6 35 60.6 70.9 0 39.8-32.2 72-72 72h-368c-39.8 0-72-32.2-72-72 0-35.9 26.3-65.4 60.6-70.9-17.3-13.1-28.6-33.7-28.6-57.1 0-39.8 32.2-72 72-72h14.1c-13.4-11.7-22.1-28.8-22.1-48 0-35.3 28.7-64 64-64h16c44.2 0 80-35.8 80-80 0-17.4-5.7-33.4-15.1-46.5 4.9-0.8 9.9-1.5 15.1-1.5 53 0 96 43 96 96 0 11.3-2.3 21.9-5.9 32h5.9c35.3 0 64 28.7 64 64 0 19.2-8.7 36.3-22.1 48h14.1c39.8 0 72 32.2 72 72 0 23.4-11.3 44-28.6 57.1zM192 256c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM351.5 395c2-5.3-2-11-7.8-11h-175.4c-5.8 0-9.8 5.7-7.8 11 10.5 27.9 58.5 53 95.5 53s85-25.1 95.5-53zM320 320c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/poo.js
// module id = 1656
// module chunks = 0